const heroText = "AI Agents for DevOps";
const subHeroText =
  "Pasoma handles deployment, monitoring, and scaling so you can focus on building. Start with Pasoma CLI today, or get early access to our cloud-based agent";
const navItems = [
  { title: "Product", link: "#product" },
  { title: "Features", link: "#features" },
  { title: "Pasoma CLI", link: "#cli" },
  { title: "Integrations", link: "#integrations" },
];

const placeHolderText = "Enter Your Email Address";

const footerText = "Scale with Pasoma";
const footerSubText =
  "The AI teammate that deploys, monitors, and scales production infrastructure.";

const footerLinks = [
  { title: "Privacy Policy", link: "privacy" },
  { title: "Terms of Service", link: "terms" },
  { title: "Cookies Policy", link: "cookies" },
];

export {
  heroText,
  subHeroText,
  navItems,
  placeHolderText,
  footerLinks,
  footerSubText,
  footerText,
};
